import type { Drift } from '../types';

interface Props {
  drift: Drift;
  onChange: (next: Drift) => void;
}

const parseSigned = (v: string) => {
  if (v === '' || v === '-' || v === '+') return 0;
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export function DriftAdjuster({ drift, onChange }: Props) {
  return (
    <section className="card-section drift-panel">
      <h2>Drift offset</h2>
      <p className="drift-help">
        Print the alignment-test PDF first. Hold the two pages up to a bright light. Read off
        the offset of page 2's center cross from page 1's, in millimeters (signed):
        <br />
        <em>dx</em> is horizontal (positive = right), <em>dy</em> is vertical (positive = down).
      </p>
      <div className="drift-inputs">
        <label>
          dx (mm)
          <input
            type="number"
            step={0.1}
            value={drift.dxMm}
            onChange={(e) => onChange({ ...drift, dxMm: parseSigned(e.target.value) })}
          />
        </label>
        <label>
          dy (mm)
          <input
            type="number"
            step={0.1}
            value={drift.dyMm}
            onChange={(e) => onChange({ ...drift, dyMm: parseSigned(e.target.value) })}
          />
        </label>
        <button
          type="button"
          className="link-btn"
          onClick={() => onChange({ dxMm: 0, dyMm: 0 })}
          disabled={drift.dxMm === 0 && drift.dyMm === 0}
        >
          Reset
        </button>
      </div>
      <p className="drift-note">
        The inside preview above re-renders with this offset applied. Re-download the PDF to bake
        it in.
      </p>
    </section>
  );
}
